export default[
    {
        path: '/folhar/evento/1270/cadastro',
        name: 'cadastro do evento', 
        component: () => import(/* webpackChunkName: "Login" */ './page/cadastro.vue')
    },
    {
        path: '/folhar/evento/1270/lista/:folhar_id',
        name: 'lista do evento do 1270', 
        component: () => import(/* webpackChunkName: "Login" */ './page/lista.vue')
    },
    {
        path: '/folhar/evento/1270/editar/:id',
        name: 'editar evento', 
        component: () => import(/* webpackChunkName: "Login" */ './page/editar.vue')
    },
]